import { useLocalizedHref } from "@/libraries/web-framework";

import {
    StaggeredFeatureList,
    featureDataProps
} from "../../../../../patterns/staggered-feature-list/staggered-feature-list";

const BuildAndSupportDoubleFeatureSection = () => {
    const featureData: featureDataProps[] = [
        {
            headingText: "Plan, track, and manage work",
            bodyText:
                "Break big ideas down into achievable steps across teams with user stories, issues, and tasks, and track it all in an easy to use board.",
            linkText: "Explore features",
            linkUrl: useLocalizedHref("/software/jira/features"),
            imageLink:
                "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-board-sparkle.webp",
            imageAltText:
                "image of Jira board showing todo and in-progress columns",
            analyticsEventLabel: "atlas-55799-jira-features-button-clicked"
        },
        {
            headingText: "Everything in one place",
            bodyText:
                "Add every piece of information you need, like docs, designs, colleagues, and more to a task, so critical context is never lost.",
            linkText: "Learn more",
            linkUrl: useLocalizedHref(
                "/software/jira/guides/issues/overview#what-is-an-issue"
            ),
            imageLink:
                "https://wac-cdn.atlassian.com/misc-assets/webp-images/jira-ticket-loop-de-loop.webp",
            imageAltText: "image of Jira issue detail view",
            analyticsEventLabel: "atlas-55799-jira-issues-button-clicked"
        }
    ];

    return (
        <StaggeredFeatureList
            mainHeadingText="Build & support world-class software"
            subHeadingText="Whether you’re agile or waterfall, writing code or running the company blog, Jira is customizable for the work you do."
            featureData={featureData}
            startingImagePosition="left"
        />
    );
};
BuildAndSupportDoubleFeatureSection.displayName =
    "BuildAndSupportDoubleFeatureSection";

export default BuildAndSupportDoubleFeatureSection;
